/* tslint:disable */
import {
  Availability
} from '../index';

declare var Object: any;
export interface AvailabilityShiftInterface {
  "sfdcId"?: string;
  "IsDeleted"?: boolean;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedDate"?: string;
  "CreatedById"?: string;
  "LastModifiedDate"?: string;
  "LastModifiedById"?: string;
  "SystemModstamp"?: string;
  "UserRecordAccessId"?: string;
  "Availability__c"?: number;
  "End_Time_24__c"?: any;
  "Shift_Hour__c"?: any;
  "Shift_Type__c"?: string;
  "Start_Time_24__c"?: any;
  "IRON_ExtID__c"?: string;
  "CreatedBy__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  availability?: Availability;
}

export class AvailabilityShift implements AvailabilityShiftInterface {
  "sfdcId": string;
  "IsDeleted": boolean;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedDate": string;
  "CreatedById": string;
  "LastModifiedDate": string;
  "LastModifiedById": string;
  "SystemModstamp": string;
  "UserRecordAccessId": string;
  "Availability__c": number;
  "End_Time_24__c": any;
  "Shift_Hour__c": any;
  "Shift_Type__c": string;
  "Start_Time_24__c": any;
  "IRON_ExtID__c": string;
  "CreatedBy__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  availability: Availability;
  constructor(data?: AvailabilityShiftInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AvailabilityShift`.
   */
  public static getModelName() {
    return "AvailabilityShift";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AvailabilityShift for dynamic purposes.
  **/
  public static factory(data: AvailabilityShiftInterface): AvailabilityShift{
    return new AvailabilityShift(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AvailabilityShift',
      plural: 'AvailabilityShifts',
      path: 'AvailabilityShifts',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "SystemModstamp": {
          name: 'SystemModstamp',
          type: 'string'
        },
        "UserRecordAccessId": {
          name: 'UserRecordAccessId',
          type: 'string'
        },
        "Availability__c": {
          name: 'Availability__c',
          type: 'number'
        },
        "End_Time_24__c": {
          name: 'End_Time_24__c',
          type: 'any'
        },
        "Shift_Hour__c": {
          name: 'Shift_Hour__c',
          type: 'any'
        },
        "Shift_Type__c": {
          name: 'Shift_Type__c',
          type: 'string'
        },
        "Start_Time_24__c": {
          name: 'Start_Time_24__c',
          type: 'any'
        },
        "IRON_ExtID__c": {
          name: 'IRON_ExtID__c',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        availability: {
          name: 'availability',
          type: 'Availability',
          model: 'Availability',
          relationType: 'belongsTo',
                  keyFrom: 'Availability__c',
          keyTo: 'id'
        },
      }
    }
  }
}
